import {
  asistenteCargaMasiva, columnasRevision, conteoPor, escapar, filaResumen, menuArchivos, menuOpciones,
  nota, notas, rangoFechas,
} from "./dialogos_carga_masiva";
import {
  descargarPlantillaEncomiendas, leerArchivoEncomiendas, recibeAvisoHoy, cambiosEncomiendaCargada, prepararCargaEncomiendas,
} from "../../functions/importar_encomiendas";
import { guardarCambiosMasivos } from "../../functions/importar_masivo";
import { opcionEliminar } from "./listado_comun";

// Ventanas de encomiendas: menú de archivos, menú de opciones de cada fila y carga desde Excel.

export const menuArchivosEncomiendas = ({ puedeCargar }) => menuArchivos({
  titulo: "Archivos de encomiendas",
  plural: "encomiendas",
  detalleExportar: "Descarga en Excel (CSV) las encomiendas que se ven en la tabla.",
  detallePlantilla: "Archivo de Excel con ejemplos para llenar las encomiendas.",
  detalleCargar: "Registra muchos paquetes de una vez desde la plantilla llena.",
  puedeCargar,
});

// cantidadFotos y tieneFirma ajustan el texto de cada tarjeta; puedeGestionar es false para residentes.
export const menuAccionesEncomienda = ({ encomienda, cantidadFotos, tieneFirma, puedeGestionar }) => menuOpciones({
  icono: "bi-box-seam",
  titulo: "Acciones de la encomienda",
  texto: `<strong>${escapar(encomienda.vivienda)}</strong>${encomienda.descripcionDomicilio ? ` · ${escapar(encomienda.descripcionDomicilio)}` : ""}<br>Estado: ${escapar(encomienda.estado || "Sin estado")}`,
  opciones: [
    { clave: "fotos", icono: "bi-image", nombre: "Ver fotos",
      detalle: cantidadFotos
        ? `${cantidadFotos} ${cantidadFotos === 1 ? "foto" : "fotos"} del paquete.`
        : "Este paquete no tiene fotos." },
    { clave: "firma", icono: "bi-vector-pen", nombre: "Ver firma",
      detalle: tieneFirma ? "Firma de quien recibió el paquete." : "Todavía no tiene firma de quien recibe." },
    ...(puedeGestionar ? [
      { clave: "gestionar", icono: "bi-pencil", nombre: "Gestionar",
        detalle: "Cambie el estado, registre quién recibe, agregue fotos o la firma." },
    ] : []),
    opcionEliminar("esta encomienda"),
  ],
});

// Devuelve true si se guardaron encomiendas.
export const asistenteCargarEncomiendas = () => asistenteCargaMasiva({
  t: {
    icono: "bi-box-seam",
    titulo: "Cargar encomiendas desde Excel",
    texto: "Registre muchos paquetes de una sola vez con un archivo de Excel (.xlsx) o CSV.",
    notaColumnas: "Tiene las mismas columnas que la tabla. Son obligatorias <strong>DIRECCIÓN</strong>, <strong>QUIÉN LO TRAE</strong> y <strong>DESCRIPCIÓN</strong>; si el paquete ya se entregó, también <strong>RECIBE</strong> y <strong>FECHA ENTREGA</strong>.",
    faltanColumnas: "<strong>DIRECCIÓN</strong>, <strong>QUIÉN LO TRAE</strong> y <strong>DESCRIPCIÓN</strong>",
    filaVacia: "Escriba debajo un paquete por fila.",
    uno: "encomienda",
    varios: "encomiendas",
    ninguno: "ninguna encomienda",
    exito: "Encomiendas cargadas",
  },
  descargarPlantilla: descargarPlantillaEncomiendas,
  leer: (archivo) => leerArchivoEncomiendas(archivo),
  guardar: (registros) => guardarCambiosMasivos(registros, cambiosEncomiendaCargada, prepararCargaEncomiendas),
  revision: (nombreArchivo, { registros, ejemplos }) => {
    const notificaHoy = registros.filter(recibeAvisoHoy).length;
    return columnasRevision([
      filaResumen("bi-file-earmark-spreadsheet", "Archivo", escapar(nombreArchivo)),
      filaResumen("bi-box-seam", "Encomiendas", registros.length),
      filaResumen("bi-houses", "Viviendas", new Set(registros.map(r => r.vivienda)).size),
      filaResumen("bi-tag", "Estados", conteoPor(registros, "estado")),
      filaResumen("bi-calendar-date", "Fecha de creación", rangoFechas(registros.map(r => r.fecha))),
    ], ejemplos) + notas(
      nota("info", "bi-info-circle",
        "Las filas sin estado quedan en <strong>Recibido</strong>. Las que estén en Recibido o Pendiente se entregan después con el botón Opciones. Las que tengan quién recibe y fecha de entrega quedan <strong>Entregado</strong>, sin firma."),
      notificaHoy > 0 &&
        nota("info", "bi-bell", `Las viviendas con paquetes recibidos hoy y aún sin entregar recibirán un aviso en la app (${notificaHoy} ${notificaHoy === 1 ? "paquete" : "paquetes"}).`),
    );
  },
});
